module.exports = __webpack_public_path__ + "static/media/uploaded.f0469584.svg";